import * as React from 'react';

import { createIcon } from '../Icon';
export const StopCircleIcon = createIcon(
  <React.Fragment>
    <circle cx={12} cy={12} r={10} />
    <rect height={6} width={6} x={9} y={9} />
  </React.Fragment>,
  'StopCircleIcon'
);
